<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: 'TERRESTRES | Ordenes Comerciales' }]"></Title>

    <v-container fluid>
      <ModalComercial
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @print="print"
        @loadList="loadList(service, getFilterParams());"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <v-card>
        <div class="row mb-5 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0 ">
                  <v-text-field
                    label="Desde*"
                    data-vv-as="desde"
                    name="desde_selected"
                    v-model="desde_selected"
                    type="date"                    
                    autocomplete="off" 
                    class="pt-0 mt-0"
                  ></v-text-field>
                  <span class="red--text">{{ errors.first("desde_selected") }}</span>                      
                </div>

                <div class="col-md-3 pt-0 ">
                  <v-text-field
                    label="Hasta*"
                    data-vv-as="hasta"
                    name="hasta_selected"
                    v-model="hasta_selected"
                    type="date"                    
                    autocomplete="off" 
                    class="pt-0 mt-0"
                  ></v-text-field>
                  <span class="red--text">{{ errors.first("hasta_selected") }}</span>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox v-model="tipo_fecha_selected" autocomplete="off" data-vv-as="tipos_fechas" name="tipos_fechas" :items="tipos_fechas" label="Fecha*" class="pt-0 mt-0" allow></v-combobox>
                </div>               
                
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="factura_selected" autocomplete="off" data-vv-as="factura" name="factura" label="Factura" class="pt-0 mt-0"></v-text-field>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field
                    v-model="referencia_cliente_selected"
                    autocomplete="off"
                    data-vv-as="referencia_cliente"
                    name="referencia_cliente"
                    label="Referencia Cliente"
                    class="pt-0 mt-0"
                  ></v-text-field>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="factura_agente_selected" autocomplete="off" data-vv-as="factura_agente" name="factura_agente" label="Factura Agente" class="pt-0 mt-0"></v-text-field>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="proformas_numero_selected" autocomplete="off" data-vv-as="proformas_numero" name="proformas_numero" label="Proformas Nº" class="pt-0 mt-0"></v-text-field>
                </div>

                <div class="col-md-3 pt-0">
                  <v-checkbox
                    v-model="alerta_fecha_selected"
                    label="Solo Alertas de Fecha"
                    class="pt-0 mt-0"
                  />                  
                </div>

                <div class="col-md-9 pt-0">

                </div>
                
                <div class="col-md-3 pt-0" style="display: flex;justify-content: end;">
                  <!--<v-btn color="error" class="mr-2" @click="export_filter">Exportar</v-btn>-->
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..." hide-default-footer disable-pagination>
          <template v-slot:item="props">
            <tr :style="getRowStyle(props.item)">  
              <td>{{ props.item.operacion }}</td>
              <td>{{ props.item.estado_operacion_api_name }}</td>
              <td>{{ showName(props.item.consignee) }}</td>
              <td>{{ props.item.crt }}</td>
              <td>{{ props.item.fecha_salida_etd }}</td>
              <td>{{ props.item.fecha_llegada_eta }}</td>
              <td>{{ props.item.fecha_llegada_ata }}</td>              
              <td>{{ showName(props.item.lugar_salida) }}</td>              
              <td>{{ showName(props.item.lugar_llegada) }}</td>

              <td class="justify-content" style="min-width:230px">
                <v-menu offset-y> 
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon color="blue-grey" v-bind="attrs" v-on="on">
                          more_vert
                      </v-icon>
                  </template>

                  <v-list>
                    
                    <v-list-item dense @click="openInformarRetraso(props.item)">
                      <v-list-item-title>
                        <font-awesome-icon icon="stopwatch" class="mr-1" color="red" />
                          Informar Retraso                            
                      </v-list-item-title>
                    </v-list-item>
                    
                    <v-list-item dense v-if="props.item.estado_operacion_api != null && props.item.estado_operacion_api == service.EstadoOperaciones_API_PENDIENTE_CONFIRMAR" 
                      @click="dialog_confirm_op = true; item_selected = props.item">
                        <v-list-item-title>
                          <font-awesome-icon icon="check" class="mr-1" color="green" />
                            Confirmar Operacion                          
                        </v-list-item-title>
                    </v-list-item>

                     <v-list-item dense @click="openHistoryRestrasos(props.item)">
                        <v-list-item-title>
                          <font-awesome-icon icon="calendar-alt" class="mr-1" />
                          Ver Retrasos</v-list-item-title
                        >
                    </v-list-item>

                    <v-list-item dense @click="openHistoryEstados(props.item)">
                        <v-list-item-title>
                          <font-awesome-icon icon="calendar-alt" class="mr-1" />
                          Ver Historial Estados</v-list-item-title
                        >
                    </v-list-item>

                    <v-list-item dense @click="copy(props.item)">
                        <v-list-item-title>
                          <font-awesome-icon icon="copy" class="mr-1" />
                          Copiar</v-list-item-title
                        >
                    </v-list-item>

                     <v-list-item dense @click="editItem(props.item)">
                        <v-list-item-title>
                            <v-icon small color="blue" class="mr-1">
                              edit
                            </v-icon>Editar</v-list-item-title
                        >
                    </v-list-item>
                    
                    <v-list-item dense @click="viewItem(props.item)">
                        <v-list-item-title>
                            <v-icon small color="blue" class="mr-1">
                              remove_red_eye
                            </v-icon>Ver</v-list-item-title
                        >
                    </v-list-item>

                    <v-list-item dense @click="deleteItem(props.item)">
                        <v-list-item-title>
                            <v-icon small color="red" class="mr-1">
                              delete
                            </v-icon>Eliminar</v-list-item-title
                        >
                    </v-list-item>
                  </v-list>
                </v-menu>

              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
      <DialogLoading :dialog="dialog_print" text="Imprimiendo..." />
      <DialogConfirm :loading="loading_confirmation" :dialog="dialog_confirm_op" @updateDialog="dialog_confirm_op = false" @action="confirmarOperacion" title="Confirmar Operacion" :text="'¿Esta seguro que desea confirmar la operación ?'" />

      <HistoryModal ref="historyStatesModal" />

      <HistoryRestrasosModal ref="historyRetrasosModal" />  

      <ModalInformarRetraso        
        :dialog="modal_informar_retraso"        
        @updateDialog="closeModalInformarRetraso"
        @loadList="filter"
        :item="mainItem"
        order_type="terrestre"
      />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/";
import { generalService } from "@/libs/ws/generalService";
import { ordersGeneralService } from "@/libs/ws/ordersGeneralService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogLoading from "@/components/DialogLoading.vue";
import ModalComercial from "./ModalComercial.vue";
import HistoryModal from "./HistoryModal.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ModalInformarRetraso from "@/components/ModalInformarRetraso.vue";
import HistoryRestrasosModal from "@/components/HistoryRestrasosModal.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";

export default {
  components: { DialogConfirm, Title, HistoryModal, ModalComercial, DialogDelete, DialogLoading, ModalInformarRetraso, HistoryRestrasosModal },
  name: "OrdersTerrestresComercial",
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      parent: this,
      service: ordersGeneralService,
      page_title: "Ordenes Terrestres",
      modal_title: "Orden Terrestre",
      modal_informar_retraso: false,
      dialog_confirm_op: false,
      loading_confirmation: false,
      mainItem: {
        id: "",
        operacion: null,
        shipper: null,
        consignee: null,
        facturas: [],        
        packing_lists: [],
        referencia_cliente: null,
        cantidad_camiones: null,
        camiones:[],
        crt: null,
        mic: null,  
        fecha_recoleccion: null,
        fecha_recoleccion_confirmada: null,
        fecha_salida_etd: null,
        fecha_salida_atd: null,
        fecha_llegada_eta: null,
        fecha_llegada_ata: null,
        ultimo_estado: null,      
        comentarios: null,
        lugar_salida: null,
        lugar_llegada: null,
        //ultimo_camion: null,
        facturas_agentes: [],        
      },
      defaultItem: null,
      headers: [
        { text: "Nº Operacion", align: "left", sortable: true, value: "operacion" },
        { text: "Estado de Operacion", align: "left", sortable: true, value: "estado_operacion_api_name" },
        { text: "Consignee", align: "left", sortable: true, value: "consignee.name" },
        { text: "CRT", align: "left", sortable: true, value: "crt" },
        { text: "Fecha Salida ETD", align: "left", sortable: true, value: "fecha_salida_etd" },
        { text: "Fecha Llegada ETA", align: "left", sortable: true, value: "fecha_llegada_eta" },
        { text: "Fecha Llegada ATA", align: "left", sortable: true, value: "fecha_llegada_ata" },        
        { text: "Lugar de salida", align: "left", sortable: true, value: "lugar_salida.name" },        
        { text: "Lugar de llegada", align: "left", sortable: true, value: "lugar_llegada.name" },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      //Dialogs
      dialog_delete: false,
      dialog_print: false,
      //Combos
      tipos_camiones: [],
      shippers: [],
      consignees: [],
      //Filters
      tipos_fechas: ["FECHA CREACION", "FECHA RECOLECCION", "FECHA RECOLECCION ( CONFIRMADA )", "FECHA SALIDA ( ETD )", "FECHA SALIDA ( ATD )", "FECHA LLEGADA ( ETA )", "FECHA LLEGADA ( ATA )"],
      tipo_fecha_selected: "FECHA CREACION",
      factura_selected: null,
      factura_agente_selected: null,
      referencia_cliente_selected: null,
      proformas_numero_selected: null,
      desde_selected_open: false,
      hasta_selected_open: false,
      alerta_fecha_selected: null,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),      
    };
  },
  mounted() {
    this.service.setSection(Constant.SECTION_ORDERS_TERRESTRES_COM);
    this.loadComboData();
    this.defaultItem = Object.assign({}, this.mainItem);
    this.loadList(this.service, this.getFilterParams());
    this.tipo_fecha_selected = this.tipos_fechas[0];
  },
  methods: {
    showName(element) {
      return element != null ? element.name : "-";
    },
    openHistoryEstados(order) {
      this.$refs.historyStatesModal.open(
        "Estados",
        [
          { text: "Fecha", align: "left", sortable: true, value: "fecha_modificacion" },
          { text: "Estado", value: "estado.name" },
        ],
        order.historial_estados,
        "fecha_modificacion",
        "estado"
      );
    },
    openHistoryBuques(order) {
      this.$refs.historyStatesModal.open(
        "Buques",
        [
          { text: "Fecha", align: "left", sortable: true, value: "fecha_modificacion" },
          { text: "Buque", value: "buque.name" },
        ],
        order.historial_buques,
        "fecha_modificacion",
        "buque"
      );
    },
    getFilterParams() {
      const param = {
        desde: this.desde_selected,
        hasta: this.hasta_selected,
        tipo_fecha: this.tipo_fecha_selected,

        proformas_numero: this.proformas_numero_selected,
        factura: this.factura_selected,
        referencia_cliente: this.referencia_cliente_selected,
        factura_agente: this.factura_agente_selected,

        alerta_fecha: (this.alerta_fecha_selected)?this.alerta_fecha_selected:null,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadComboData() {
      generalService.filter({}, "shippers").then((response) => {
        this.shippers = response.result;
      });
      generalService.filter({}, "consignees").then((response) => {
        this.consignees = response.result;
      });
      generalService.filter({}, "tipos_camiones").then((response) => {
        this.tipos_camiones = response.result;
      });
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service, this.getFilterParams());
    },
    updateDialog(value, next_flag = false) {
      this.mainItem = JSON.parse(JSON.stringify(this.defaultItem));
      if (!value) {
        this.closeModal(next_flag);
      } else {
        this.dialog = value;
      }
    },
    closeModal(next_flag) {
      if (!next_flag) {
        this.dialog = false;
        this.close();
        return;
      }

      const mainItem_aux = this.mainItem;

      this.mainItem = Object.assign({}, this.defaultItem);

      this.mainItem.shipper = mainItem_aux.shipper;
      this.mainItem.consignee = mainItem_aux.consignee;

      this.dialog = false;
      this.editedIndex = -1;
      this.viewdIndex = -1;
      this.errors.clear();
    },
    export_filter() {
      this.service.export_filter(this.getFilterParams()).then((response) => {
        try {
          //Transformo a string la respuesta para poder enviar mensajes de error.
          let result = JSON.parse(this.arrayBufferToString(response));
          if (!result.status) {
            this.$toast.error(result.msg, "Error");
          }
        } catch (e) {
          let blob = new Blob([response], {
            type: "application/vnd.ms-excel",
          });
          let link = document.createElement("a");
          //link.setAttribute('download', "export")
          link.download = "reporte.xlsx";
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          //link.download = code+'.pdf'
          link.click();
        }
      });
    },
    copy(orden) {
      this.errors.clear();
      this.loading = true;

      this.mainItem.shipper = orden.shipper;
      this.mainItem.consignee = orden.consignee;            
      this.referencia_cliente = orden.referencia_cliente;      
      this.mainItem.crt = orden.crt;
      this.mainItem.mic = orden.mic;            
      this.mainItem.comentarios = orden.comentarios;
                  
      //Get Next Operaciones
      this.service.getNextOperacion().then((response) => {
        this.mainItem.operacion = response.result;
        this.dialog = true;
      })
      .catch((error) => {
        this.$toast.error(error, "Error");
      })
      .finally(() => {
        this.loading = false;
      });
    },
    print(orden, type) {
      this.dialog_print = true;
      this.service.print(orden.id, type).then((response) => {
        try {
          //Transformo a string la respuesta para poder enviar mensajes de error.
          let result = JSON.parse(this.arrayBufferToString(response));
          if (!result.status) {
            this.$toast.error(result.msg, "Error");
          }
          this.dialog_print = false;
        } catch (e) {
          this.dialog_print = false;
          let blob = new Blob([response], {
            type: "application/pdf",
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = orden.guia_madre + ".pdf";
          link.target = "_blank";
          link.click();
        }
      });
    },
    getRowStyle(item) {
      let style = "";
      if (item.alerta_fecha != null && item.alerta_fecha) {
        style += "background-color: #ffa571;";
      }
      
      if(item.closed){
        style += "background-color: #cdcdcd;";
      }     

      return style;   
    },
    closeModalInformarRetraso() {
      this.modal_informar_retraso = false;
    },
    openInformarRetraso(item) {
      this.mainItem = item;
      this.modal_informar_retraso = true;
    },
    openHistoryRestrasos(order) {
      this.$refs.historyRetrasosModal.open(
        "Retrasos",      
        order.historial_retrasos,
      );
    },
    confirmarOperacion(){
      if(this.item_selected == null){
        this.$toast.error("No se selecciono ningun elemento", "Error");
        return;
      }

      this.loading_confirmation = true;
      this.service.confirmarOperacion({ id: this.item_selected.id }).then((response) => {
        try {                    
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
          } else {
            this.dialog_confirm_op = false;
            this.$toast.success("Operacion Confirmada", "Exito");
            this.loadList(this.service, this.getFilterParams());
          }
        } catch (e) {
          this.$toast.error(e, "Error");
        }
      })
      .catch((error) => {
        this.$toast.error(error, "Error");
      })
      .finally(() => {
        this.loading_confirmation = false;
      });
    }
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
